import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/optimized/logo.png";
import { siteInfo } from "../data/siteInfo";
import Icon from "../components/Icon";
import "../css/Navbar.css";

const links = [
  { label: "Open Play", to: "/#open-play" },
  { label: "Birthday Parties", to: "/packagesdetail" },
  { label: "The Playground", to: "/#gallery" },
  { label: "FAQ", to: "/#waiver" },
  { label: "Visit Us", to: "/#contact" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname, hash } = useLocation();
  const headerRef = useRef(null);
  const toggleRef = useRef(null);
  useEffect(() => {
    setMenuOpen(false);
  }, [pathname, hash]);
  useEffect(() => {
    if (!menuOpen) return undefined;
    const closeOutside = (event) => {
      if (!headerRef.current?.contains(event.target)) setMenuOpen(false);
    };
    const resize = () => {
      if (window.innerWidth >= 1040) setMenuOpen(false);
    };
    document.addEventListener("pointerdown", closeOutside);
    window.addEventListener("resize", resize);
    return () => {
      document.removeEventListener("pointerdown", closeOutside);
      window.removeEventListener("resize", resize);
    };
  }, [menuOpen]);
  const isCurrent = (to) =>
    to === "/packagesdetail"
      ? pathname === "/packagesdetail" || pathname === "/book"
      : pathname === "/" && to === `/${hash}`;
  const navLinks = links.map((link) => (
    <Link
      key={link.to}
      to={link.to}
      aria-current={isCurrent(link.to) ? "page" : undefined}
      onClick={() => setMenuOpen(false)}
    >
      {link.label}
    </Link>
  ));
  return (
    <header
      className="site-header"
      ref={headerRef}
      onKeyDown={(event) => {
        if (event.key === "Escape" && menuOpen) {
          setMenuOpen(false);
          toggleRef.current?.focus();
        }
      }}
    >
      <div className="header-inner site-container">
        <Link
          to="/#home"
          className="brand-link"
          aria-label="Kiddie Kingdom home"
        >
          <img src={logo} width="480" height="176" alt="Kiddie Kingdom" />
        </Link>
        <nav className="desktop-nav" aria-label="Main navigation">
          {navLinks}
        </nav>
        <div className="header-actions">
          <Link className="button button-primary header-booking" to="/book">
            Book a Party <Icon />
          </Link>
          <button
            ref={toggleRef}
            className="menu-toggle icon-button"
            type="button"
            aria-expanded={menuOpen}
            aria-controls="mobile-navigation"
            aria-label={menuOpen ? "Close navigation" : "Open navigation"}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <Icon name={menuOpen ? "close" : "menu"} />
          </button>
        </div>
      </div>
      {menuOpen && (
        <nav
          id="mobile-navigation"
          className="mobile-nav"
          aria-label="Mobile navigation"
        >
          {navLinks}
          <a href={siteInfo.waiver} target="_blank" rel="noopener noreferrer">
            Sign the waiver <Icon name="external" />
          </a>
          <a href={siteInfo.phoneHref}>
            <Icon name="phone" /> {siteInfo.phone}
          </a>
          <Link
            to="/book"
            onClick={() => setMenuOpen(false)}
            className="button button-primary"
          >
            Book a Party <Icon />
          </Link>
        </nav>
      )}
    </header>
  );
}
